// Utilities that deal with Authentication
import { VistaprintAuth } from '@vp/auth-react';
import { getCurrentLocale } from './locale';
import { isCareAgent, isLocalhost, isBranchOrStagingEnv } from './utils';

export async function getAuthIdentity() {
    const options = {
        developmentMode: isLocalhost() || isBranchOrStagingEnv()
            ? {
                // Overwrite this for development since we control this auth0 client
                // this is a cimpress-issued client
                // https://access.cimpress.io/access-management/clients/a9f3de5b462435867d1444e6b473b745
                clientID: 'a9f3de5b462435867d1444e6b473b745',
                redirectUriOrigin: window.location.origin,
                domain: 'oauth.cimpress.io',
            }
            : false,
        culture: getCurrentLocale(),
    };
    if (isCareAgent()) {
        options.options = {
            connection: 'vistaprintcom-okta',
            clientID: 'tCZE1T00Yk6Uqs4jLO0HtpwLopz8BN7F',
        };
    }
    return VistaprintAuth.init(options);
}

export async function getAuthToken() {
    await getAuthIdentity();
    return new VistaprintAuth.WebAuth().getToken();
}

export async function authLogin() {
    await getAuthIdentity();
    if (!new VistaprintAuth.WebAuth().isSignedIn()) {
        return new VistaprintAuth.WebAuth().signIn();
    }
    return true;
}

export async function isSignedIn() {
    await getAuthIdentity();
    return new VistaprintAuth.WebAuth().isSignedIn();
}

export function getCanonicalId() {
    return new VistaprintAuth.WebAuth().getCanonicalId();
}
